import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { filter, firstValueFrom, take } from 'rxjs';
import { SystemService } from '@shared/service/system/system.service';
import { AuthService } from '../auth/service/auth.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class DictionaryDetailsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);

  private systemService = inject(SystemService);
  private authService = inject(AuthService);

  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    await firstValueFrom(
      this.systemService.isInitialized$.pipe(
        filter((val) => val),
        take(1),
      ),
    );
    const hasPermission = this.authService.getRoutePermissions("/dictionaries");
    if (!hasPermission) { return false; }

    return await this.routeGuardService.handleRoute(this.getView(route), route);
  }

  getView(route: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `dictionaries/${uuid}`,
      iframeUrl: `dictionary/${uuid}`,
    };
  }
}
